import { render, staticRenderFns } from "./ProfileRequests.vue?vue&type=template&id=9f040d94&"
import script from "./ProfileRequests.vue?vue&type=script&lang=js&"
export * from "./ProfileRequests.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports